import { sendRequest } from "../sendRequest";

export const sendOTP = ({ phoneNumber }) => {
  return sendRequest("post", `/admin/custom-login/otp`, {
    userIdentifier: String(phoneNumber),
    userType: "influencer",
  }).then((res) => res.data);
};
